import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { SalesButton } from '../ui/SalesButton';
import { ShieldIcon, ClockIcon, GiftIcon, CheckIcon } from 'lucide-react';
export function FinalCtaSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} id="precio" className="bg-[#1a2744] py-20 lg:py-28 relative overflow-hidden" data-id="element-63">
      {/* Background decorations */}
      <div className="absolute top-0 left-0 w-full h-full" data-id="element-64">
        <div className="absolute top-20 left-10 w-32 h-32 bg-[#c9a227]/10 rounded-full blur-2xl" data-id="element-65" />
        <div className="absolute bottom-20 right-10 w-48 h-48 bg-[#c9a227]/10 rounded-full blur-3xl" data-id="element-66" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-67">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-68">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-red-500/20 text-red-400 rounded-full text-sm font-semibold mb-6" data-id="element-69">
            <ClockIcon className="w-4 h-4" data-id="element-70" />
            No Esperes a Marzo Para Entrar en Pánico
          </div>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight mb-6" data-id="element-71">
            El IRS No Perdona el Olvido, <br className="hidden sm:block" data-id="element-72" />
            <span className="text-[#c9a227]" data-id="element-73">Pero Premia la Preparación</span>
          </h2>

          <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto" data-id="element-74">
            Cada día que pasa sin esta información es dinero que estás dejando
            en la mesa.
            <strong className="text-white" data-id="element-75">
              {' '}
              Toma control de tus impuestos hoy.
            </strong>
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-[#243352] rounded-3xl p-8 lg:p-12 mb-12 border border-[#c9a227]/20" data-id="element-76">
          <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-77">
            <div className="text-left" data-id="element-78">
              <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-79">
                <ShieldIcon className="w-8 h-8 text-[#c9a227]" data-id="element-80" />
                Tu Paquete Incluye:
              </h3>
              <ul className="space-y-4" data-id="element-81">
                <li className="flex items-start gap-3" data-id="element-82">
                  <CheckIcon className="w-5 h-5 text-[#c9a227] flex-shrink-0 mt-1" data-id="element-83" />
                  <span className="text-gray-300" data-id="element-84">
                    <strong className="text-white" data-id="element-85">El Escudo 1099</strong> —
                    Guía completa de 60+ páginas (Valor: $97)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-86">
                  <CheckIcon className="w-5 h-5 text-[#c9a227] flex-shrink-0 mt-1" data-id="element-87" />
                  <span className="text-gray-300" data-id="element-88">
                    <strong className="text-white" data-id="element-89">
                      Lista Maestra de Deducciones
                    </strong>{' '}
                    — Checklist imprimible (Valor: $27)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-90">
                  <GiftIcon className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" data-id="element-91" />
                  <span className="text-gray-300" data-id="element-92">
                    <strong className="text-green-400" data-id="element-93">BONUS:</strong> Tabla de
                    Rastreo de Millaje 2025 (Valor: $47)
                  </span>
                </li>
              </ul>
              <div className="mt-6 pt-6 border-t border-gray-700" data-id="element-94">
                <p className="text-gray-400" data-id="element-95">
                  Valor Total: <span className="line-through" data-id="element-96">$171</span>
                </p>
                <p className="text-2xl font-bold text-white" data-id="element-97">
                  Hoy Solo Pagas: <span className="text-[#c9a227]" data-id="element-98">$6.39</span>
                </p>
              </div>
            </div>

            <div className="text-center" data-id="element-99">
              <div className="bg-[#1a2744] rounded-2xl p-6 mb-6" data-id="element-100">
                <p className="text-gray-400 text-sm mb-2" data-id="element-101">
                  Precio de Lanzamiento
                </p>
                <div className="flex items-baseline justify-center gap-2 mb-2" data-id="element-102">
                  <span className="text-gray-500 line-through text-3xl" data-id="element-103">
                    $27
                  </span>
                  <span className="text-6xl font-bold text-[#c9a227]" data-id="element-104">
                    $6.39
                  </span>
                </div>
                <p className="text-green-400 font-semibold" data-id="element-105">¡Ahorras $20.61!</p>
              </div>

              <div id="obtener-escudo" data-id="element-106">
                <SalesButton size="large" className="w-full mb-4" data-id="element-107">
                  🛡️ OBTENER MI ESCUDO AHORA
                </SalesButton>
              </div>

              <p className="text-sm text-gray-500" data-id="element-108">
                Descarga inmediata • Pago seguro
              </p>
            </div>
          </div>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-gray-400 max-w-2xl mx-auto" data-id="element-109">
          <strong className="text-white" data-id="element-110">Recuerda:</strong> La guía de $6.39 que
          te ahorra miles en impuestos. No dejes que otro año pase pagando más
          de lo que debes.
        </motion.p>
      </div>
    </section>;
}